/** Keep card variant images without replacing the shared product API. */
export const API_CONFIG = {
  timeoutMs: 0,
  productVariantImages: true as boolean | undefined,
  stableCategoryDetails: false,
};
